import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<circle cx=\"15\" cy=\"9\" r=\"3.5\"></circle><path d=\"M9 24v-1.5a6 6 0 0 1 12 0V24\"></path><circle cx=\"7\" cy=\"11.5\" r=\"2.5\"></circle><circle cx=\"23\" cy=\"11.5\" r=\"2.5\"></circle><path d=\"M3.5 22v-1a4 4 0 0 1 4-4m19 5v-1a4 4 0 0 0-4-4\"></path>", 5)
  ]))]))
}
export default { render: render }